<div
    id="splitButton"
    class="d-inline-block"
    [classList]="classList"
    (focusout)="onMenuBlur()">
    <!-- This should render out a button element -->
    <ng-content></ng-content>
    <button
        nbButton
        [status]="status"
        [size]="size"
        [nbContextMenu]="menu?.items || []"
        [nbContextMenuTag]="menu?.tag || ''"
        nbContextMenuTrigger="click"
        (click)="onMenuClick($event)"
        class="h-100 remove-border-left">
        <nb-icon icon="arrow-down-outline"></nb-icon>
    </button>
</div>
